import React from 'react';

export interface IPaginationProps {
	page: number;
	onChange: (page: number) => any;
	total: number;
	disabled?: boolean;
}

const Pagination: React.FC<IPaginationProps> = ({ page, onChange, total, disabled }) => {
	return (
		<div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
			<button
				className='icon-button'
				disabled={page === 1 || total === 1 || disabled}
				onClick={() => onChange(1)}
			>
				<i className='fa-regular fa-backward-step'></i>
			</button>
			<div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
				{page === 1 ? (
					<div style={{ width: '24px', height: '24px' }}></div>
				) : (
					<button
						className='icon-button'
						disabled={total === 1 || disabled}
						onClick={() => onChange(page - 1)}
					>
						{page - 1}
					</button>
				)}
				<button
					className={['icon-button', ...(total === 1 ? [] : ['selected'])].join(
						' '
					)}
					disabled={total === 1 || disabled}
					style={{ width: '32px', height: '32px', borderRadius: '50%' }}
				>
					{page}
				</button>
				{page === total ? (
					<div style={{ width: '24px', height: '24px' }}></div>
				) : (
					<button
						className='icon-button'
						disabled={total === 1 || disabled}
						onClick={() => onChange(page + 1)}
					>
						{page + 1}
					</button>
				)}
			</div>
			<button
				className='icon-button'
				disabled={page === total || total === 1 || disabled}
				onClick={() => onChange(total)}
			>
				<i className='fa-regular fa-forward-step'></i>
			</button>
		</div>
	);
};

export default Pagination;
